import { types as api } from '@mesa-labs/mesa-api';
import React from 'react';
import { ActionItemStatuses, actionItemStatusLabel, assigneeOptions } from '../../../../utils/vendorActionItems';


// <option>s for a native status <select>, in lifecycle order.
export function StatusOptions(): React.ReactElement {
  return <>{ActionItemStatuses.map((s) => <option key={s} value={s}>{actionItemStatusLabel(s)}</option>)}</>;
}

type AssigneeOptionsProps = {
  operators: readonly api.VendorActionItemAssigneeResponse[];
  me?: string;
  // The item's current assignee, kept selectable after they stop being an operator.
  current?: string;
};

// <option>s for a native assignee <select>; callers add their own empty option if they need one.
export function AssigneeOptions({ operators, me, current }: AssigneeOptionsProps): React.ReactElement {
  return <>{assigneeOptions(operators, me, current).map(({ value, label }) => <option key={value} value={value}>{label}</option>)}</>;
}
